import strings from "../lang/Localiz";
import React, { useRef } from "react";
import useStore from "../store";
import useClickOutside from "../utils/useOnClickOutside";

export default function HudTravelHint({ dismissPicker }) {
  const new_Step = useStore((state) => state.new_Step);
  const picker = useRef(null);

  const stepMove = () => {
    new_Step();
    dismissPicker();
  };

  useClickOutside(picker, dismissPicker);

  return (
    <div ref={picker} className={"hud-travel-hint"}>
      {strings.bones.button.throw}
      <div className={"hud-travel-hint-desc"}>
        {strings.bones.button.cost}
        <div className={"hud-energy"}>
          <span /> 10
        </div>
      </div>
      <div onClick={() => stepMove()} className={"btn-simple btn-approve"}>
        {strings.bones.button.accept}
      </div>
    </div>
  );
}
